import React from 'react';
import HighlightText from "../components/core/HomePage/HighlightText"
import BannerImage1 from "../assets/Images/aboutus1.webp"
import BannerImage2 from "../assets/Images/aboutus2.webp"
import BannerImage3 from "../assets/Images/aboutus3.webp"
import Quote from '../components/core/AboutPage/Quote';
import FoundingStory from "../assets/Images/FoundingStory.png"
import StatsComponent from '../components/core/AboutPage/StatsComponent';
import LearningGrid from '../components/core/AboutPage/LearningGrid';
import Footer from "../components/common/Footer";
import ContactForm from "../components/core/AboutPage/ContactForm";
import ReviewSlider from '../components/common/ReviewSlider';

function About(props) {
    return (
        <div>
            {/* section 1 */}
            <section className='bg-richblack-800'>
                <div className='flex flex-col relative justify-center items-center gap-4'>
                    <p className='text-richblack-100 text-center mt-14 '>About us</p>
                    <header className='flex flex-col items-center justify-center text-center w-[70%] mt-5'>
                        <p className='text-richblack-25 w-[60%] max-[450px]:w-[90%] text-3xl font-semibold'>Driving Innovation in Online Education for a
                        <HighlightText text={"Brighter Future"}/></p>
                        <p className='text-richblack-200 mt-4'>
                            Studynotion is at the forefront of driving innovation in online education. We're passionate about creating a brighter future by offering cutting-edge courses, leveraging emerging technologies, and nurturing a vibrant learning community.
                        </p>
                    </header>
                    <div className='flex gap-4 items-center absolute max-[450px]:flex-col translate-y-[60%] justify-center'>
                        <img className='max-[450px]:w-[80%]' src={BannerImage1} alt="" />
                        <img className='max-[450px]:w-[80%]' src={BannerImage2} alt="" />
                        <img className='max-[450px]:hidden' src={BannerImage3} alt="" />
                    </div>
                    <div className='h-[20rem] max-[450px]:h-[30rem]'></div>
                </div>
            </section>

            {/* section 2 */}
            <section className=''>
                <div className='flex justify-center mt-32 mb-20'>
                    {/* quote */}
                    <Quote/>
                </div>
            </section>

            {/* section 3 */}
            <section>
                <div className='flex flex-row max-[450px]:flex-col justify-center items-center'>
                    {/* left */}
                    <div className='w-[50%] max-[450px]:w-[90%] max-[450px]:'>
                        <div className='text-3xl font-bold bg-gradient-to-br from-[#833AB4] text-transparent via-[#FD1D1D] to-[#FCB045] bg-clip-text'>Our Founding Story </div>
                        <div className='text-richblack-50 w-[80%] max-[450px]:w-full mt-2'>
                            <div>
                                Our e-learning platform was born out of a shared vision and passion for transforming education. It all began with a group of educators, technologists, and lifelong learners who recognized the need for accessible, flexible, and high-quality learning opportunities in a rapidly evolving digital world.
                            </div>
                            <br />
                            <div>
                                As experienced educators ourselves, we witnessed firsthand the limitations and challenges of traditional education systems. We believed that education should not be confined to the walls of a classroom or restricted by geographical boundaries. We envisioned a platform that could bridge these gaps and empower individuals from all walks of life to unlock their full potential.
                            </div>
                        </div>
                    </div>
                    {/* right */}
                    <div className='flex justify-center max-[450px]:mt-10'>
                        <img className='max-[450px]:w-[70%] shadow-[5px_15px_50px_rgba(8,_112,_184,_0.7)] hover:scale-105 transition-all duration-200' src={FoundingStory} alt="" />
                    </div>
                </div>
                <div className='flex flex-row max-[450px]:flex-col items-center justify-center mt-32'>
                    <div className='flex flex-row max-[450px]:flex-col justify-center gap-4 w-[80%]'>
                        {/* left */}
                        <div className='w-[50%] max-[450px]:w-[100%]'>
                            <div className='text-3xl font-bold bg-gradient-to-br from-[#E65C00] text-transparent via-[#F9D423] to-[#F9D423] bg-clip-text'>Our Vision</div>
                            <div className='text-richblack-50 mt-4'>With this vision in mind, we set out on a journey to create an e-learning platform that would revolutionize the way people learn. Our team of dedicated experts worked tirelessly to develop a robust and intuitive platform that combines cutting-edge technology with engaging content, fostering a dynamic and interactive learning experience.</div>
                        </div>
                        {/* right */}
                        <div className='w-[50%] max-[450px]:w-[100%] max-[450px]:mt-5'>
                            <div className='text-2xl font-bold bg-gradient-to-tr from-[#1FA2FF] text-transparent via-[#12D8FA] to-[#A6FFCB] bg-clip-text'>Our Mission</div>
                            <div className='text-richblack-50 mt-4'>our mission goes beyond just delivering courses online. We wanted to create a vibrant community of learners, where individuals can connect, collaborate, and learn from one another. We believe that knowledge thrives in an environment of sharing and dialogue, and we foster this spirit of collaboration through forums, live sessions, and networking opportunities.</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* section 4 */}
            <section className='mt-14'>
                <StatsComponent/>
            </section>

            {/* section 5 */}
            <section className='mx-auto flex items-center justify-center  max-w-maxContent'>
                <LearningGrid/>
            </section>

            <section className='mx-auto flex items-center justify-center  max-w-maxContent'>
                <ContactForm/>
            </section>
            
            <section className='flex justify-center'>
                <h1 className='text-richblack-25 max-[450px]:hidden text-3xl text-semibold'>Reviews from other learners</h1>
            </section>

            <div className="w-11/12 mx-auto mt-2 max-[450px]:hidden max-w-maxContent flex flex-col items-center justify-between gap-7 bg-richblack-900 text-white">
            <ReviewSlider/>
            </div>

            {/* footer */}
            <section>
                <Footer/>
            </section>
        </div>
    );
}

export default About;